import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { QueueDriverPage } from "./queue-driver/queue-driver.page";
import { Routes, RouterModule } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ComponentsModule } from "../components/component.module";
import { StartRacePage } from "./start-race/start-race.page";
import { InfoQueuePage } from "./info-queue/info-queue.page";
import { CurrentRacePage } from "./current-race/current-race.page";
import { FinallyRacePage } from "./finally-race/finally-race.page";
import { PaymentMethodsPage } from "./payment-methods/payment-methods.page";
import { PaymentMethodModalComponent } from "./payment-methods/payment-method-modal/payment-method-modal.component";
import { PaymentCompleteComponent } from "./payment-complete/payment-complete.component";
import { PayPlatformPage } from "./pay-platform/pay-platform.page";

const COMPONENTS = [
  QueueDriverPage,
  StartRacePage,
  InfoQueuePage,
  CurrentRacePage,
  FinallyRacePage,
  PaymentMethodsPage,
  PaymentMethodModalComponent,
  PayPlatformPage,
];

const routes: Routes = [
  {
    path: "queue",
    component: QueueDriverPage,
  },
  {
    path: "information-queue",
    component: InfoQueuePage,
  },
  {
    path: "start",
    component: StartRacePage,
  },
  {
    path: "current-race",
    component: CurrentRacePage,
  },
  {
    path: "payment-methods",
    component: PaymentMethodsPage,
  },
  {
    path: "payment-complete",
    component: PaymentCompleteComponent,
  },
  {
    path: "pay-platform",
    component: PayPlatformPage,
  },
  {
    path: "",
    redirectTo: "queue",
    pathMatch: "full",
  },
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
})
export class DriverModule {}
